import { injectable } from 'inversify-props';
import { plainToClass } from 'class-transformer';
import BaseService from '@/services/base-service';
import ClientNoteModel from '@/models/crm/client-note.model';
import ClientNoteFeaturedModel from '@/models/crm/client-note-featured.model';
import { PaginationModel } from '@/models/pagination.model';
import { RequestConfig } from '@/interfaces/request-config.interface';
import { ClientTypeEnum } from '@/enums/client-type.enum';

@injectable()
export default class ClientNoteService extends BaseService {
  private get baseUrl(): string {
    return `${this.getApiPath()}/crm/client-notes`;
  }

  async list(
    clientId: string,
    type: ClientTypeEnum,
    limit: number,
    offset = 0,
    keyword?: string,
  ): Promise<PaginationModel<ClientNoteModel>> {
    const config: RequestConfig = {
      params: { clientId, type, limit, offset, keyword: keyword || undefined },
    };
    const result = (await this.httpService.get(
      PaginationModel,
      this.baseUrl,
      config,
    )) as PaginationModel<ClientNoteModel>;
    result.results = plainToClass(ClientNoteModel, result.results || []);
    return result;
  }

  async featured(clientId: string, type: ClientTypeEnum): Promise<ClientNoteFeaturedModel> {
    const config: RequestConfig = { params: { clientId, type } };
    const result = (await this.httpService.get(
      ClientNoteFeaturedModel,
      `${this.baseUrl}/featured`,
      config,
    )) as ClientNoteFeaturedModel;
    result.note = result.note ? plainToClass(ClientNoteModel, result.note) : null;
    return result;
  }

  async create(
    clientId: string,
    type: ClientTypeEnum,
    observacao: string,
    destaque: boolean,
  ): Promise<ClientNoteModel> {
    return (await this.httpService.post(ClientNoteModel, this.baseUrl, {
      clientId,
      type,
      observacao,
      destaque,
    })) as ClientNoteModel;
  }

  async setHighlight(id: number, destaque: boolean): Promise<ClientNoteModel> {
    return (await this.httpService.put(ClientNoteModel, `${this.baseUrl}/${id}/highlight`, {
      destaque,
    })) as ClientNoteModel;
  }
}
